export default function GroupInfoScreen() {
  return null;
}